import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError, from } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { AuthService } from "../services/authService";
import { RecaptchaService } from "../services/recaptcha.service";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly MAX_RETRY = 1;

  constructor(
    private authService: AuthService,
    private recaptchaService: RecaptchaService,
    private toastr: ToastrService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (request.url.includes("configmanager-pss.safewebpss.com.br/service/ApiConfig/config/get")) {
      return next.handle(request);
    }

    let accessToken = sessionStorage.getItem("tokenAutentication");
    if (accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `${accessToken}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {

          const retryKey = `retry-${request.url}`;
          const currentRetry = parseInt(sessionStorage.getItem(retryKey) || "0", 10);

          if (currentRetry >= this.MAX_RETRY) {
            Object.keys(sessionStorage).forEach((key) => {
              if (key.startsWith("retry-")) {
                sessionStorage.removeItem(key);
              }
            });
            this.toastr.error("Serviço temporariamente indisponível. Tente novamente mais tarde.");
            return throwError(new Error('Limite de tentativas atingido.'));
          }

          sessionStorage.setItem(retryKey, (currentRetry + 1).toString());

          return from(
            this.recaptchaService.executarRecaptcha("importantAction")
          ).pipe(
            switchMap((recaptchaToken) =>
              this.authService.autenticacao(recaptchaToken).pipe(
                switchMap((novoToken) => {
                  if (
                    novoToken?.tokenAcesso &&
                    novoToken.tokenAcesso.trim() !== ""
                  ) {
                    sessionStorage.setItem(
                      "tokenAutentication",
                      novoToken.tokenAcesso
                    );
                    Object.keys(sessionStorage).forEach((key) => {
                      if (key.startsWith("retry-")) {
                        sessionStorage.removeItem(key);
                      }
                    });
                    const newRequest = request.clone({
                      headers: request.headers.set(
                        "Authorization",
                        `${novoToken.tokenAcesso}`
                      ),
                    });

                    return next.handle(newRequest);
                  } else {
                    return throwError(new Error("Erro ao renovar token"));
                  }
                })
              )
            ),
            catchError((refreshError) => throwError(refreshError))
          );
        }

        return throwError(error);
      })
    );
  }
}
